    import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
    import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
    import { WallboardViewService } from '../wallboard-view.service';
    import { _stateColors } from '../../../dashboard/modules/current-agent-states/current-agent-states.models';
    import { EState } from '../../../../AngularJS/Dashboard/Models/agent-state';
import { WVBase, WVMain } from '../wallboard-view.model';
import { ModuleType } from '../../wallboards.model';

    @Component({
	    selector: 'cv-wallboard-view-current-agent-states-responsive',
	    templateUrl: './wallboard-view-current-agent-states-responsive.component.html',
	    styleUrls: ['./wallboard-view-current-agent-states-responsive.component.scss']
    })
    export class WallboardViewCurrentAgentStatesResponsiveComponent implements OnInit, OnDestroy {

	    @Input() firstSlide = false;
  
	    public wvf: WVMain;
	    public wvcasf: WVBase;
	    public currentAgentStatesData;
        public currentAgentStatesState;
        public localization: Map<string, string>;

        private dataUpdated: boolean = false;
        public tableHeight: number = 0;

	    private updateTimerRef:NodeJS.Timeout = null;
	    private isDestroyed:boolean = false;

        public paddedData = [[], [], []];

        get hasBackdrop(): boolean {
            return this.wvcasf?.Slide.HasBackdrop ?? false;
        }

        get moduleKey(): string {
            return this.wvcasf?.Slide.WallboardModuleDetails[0].WallboardModuleKey ?? "";
        }

        get backgroundID(): number {
            return this.wvcasf?.Slide.BackgroundImageID ?? 0;
        }

	    constructor(
	        private service: WallboardViewService,
            private cvLocalization: CVLocalizationService,
            private cdr: ChangeDetectorRef
	    ) { }

	    async ngOnInit(): Promise<void> {
	        this.wvf = this.service.WVMain;
	        this.wvcasf = this.service.WVAgentStatesResponsive;

            this.wvf.RunSlide = this.firstSlide;
            if (!this.firstSlide)
                this.wvf.NextSlideReady = false;

	        this.localization = await this.cvLocalization.GetSection("Module");

            let moduleState = this.service.loadModuleState(ModuleType.ResponsiveCurrentAgentStates, this.wvf.WallboardCreatorID, this.moduleKey).then(response => {
                if (this.isDestroyed)
                    return;

                this.currentAgentStatesState = response.currentAgentStatesObj;
            });

            let currentAgentStatesModuleData = this.service.getCurrentAgentStatesResponsiveModuleData(this.wvcasf.Slide.WallboardID, this.moduleKey).then(response => {
                if (this.isDestroyed)
                    return;

                this.currentAgentStatesData = response;
            });

            Promise.all([moduleState, currentAgentStatesModuleData]).then(responses => {
                if (this.firstSlide)
                    this.wvf.FirstSlideReady = true;
                else
                    this.wvf.NextSlideReady = true;

                let $viewSlide = angular.element(document).find('.wallboardViewSlide');
                $viewSlide.height('100vh');
                this.tableHeight = $viewSlide.height() - 132;

                this.runSlide();
            });
	    }

	    ngOnDestroy(): void {
		    //end data updates
		    if(this.updateTimerRef != null){
			    clearInterval(this.updateTimerRef);
		    }

		    this.isDestroyed = true;
	    }

	    getLimitTo = function (index) {
	        let conHeight = $($(".wvCurrentAgentStatesColumn")[index]).height() - $($(".wvCurrentAgentStatesColumnTitle")[index]).outerHeight();
	        let rowHeight = $($(".wvCurrentAgentStatesGridCell")[index]).outerHeight();

	        if (conHeight < rowHeight) {
		        conHeight = $($(".wvCurrentAgentStatesColumn")[index]).height() - rowHeight;
	        }

	        let rows = conHeight / rowHeight;
	        return rows % 1 < 0.75 ? Math.floor(rows) - 1 : Math.floor(rows);
	    }

        /**
        * Used to fill the ng-repeats with blank data so the css grid doesn't center them vertically when there aren't enough rows.
        * @param index Index of box to find max size for; 0 for OnCall, 1 for Unavailable, 2 for Available
        * @param data Data that is being repeated over
        * @param includedProperties List of properties to include in the blank data. All of these will be set to empty string ("")
        */
        fillColumn(index: number, data: any[], includedProperties: string[]): void {
            if (!data || !this.currentAgentStatesData)
                this.paddedData = [[], [], []];

            let maxDataRows = this.getLimitTo(index);
            if (isNaN(maxDataRows) || maxDataRows === Infinity)
                maxDataRows = 10;

            let paddedData = angular.copy(data);

            while (paddedData?.length < maxDataRows) {
                let padding = {};
                for (let i = 0; i < includedProperties.length; i++) {
                    padding[includedProperties[i]] = "";
                }

                paddedData.push(padding);
            }

            this.paddedData[index] = paddedData.slice(0, maxDataRows);
        }

        async runSlide() {
            if (!this.dataUpdated) {
                // Reload the data every 5 secs.
                this.updateTimerRef = setInterval(() => {
                    this.updateSlideData();
                    this.fillColumn(0, this.currentAgentStatesData?.AllAgentStates, ['groupName, state']);
                    this.fillColumn(1, this.currentAgentStatesData?.AllAgentStates, ['stateName']);
                    this.fillColumn(2, this.currentAgentStatesData?.AllAgentStates, ['stateTime']);
                    this.fillColumn(3, this.currentAgentStatesData?.AllAgentStates, ['parentGroupName']);
                    this.fillColumn(4, this.currentAgentStatesData?.AllAgentStates, ['skill']);
                }, 5000);

                this.dataUpdated = true;
            }

            if (this.wvf.RunSlide) {
                setTimeout(() => {
                    // Was originally this.currentAgentStatesData.length, but that makes no sense because this.currentAgentStatesData is not an array or other collection.
                    // This is the closest thing that even approximates something coherent.
                    for (let i = 0; i < this.currentAgentStatesData?.OnCall?.length; i++) {
                        this.animateRow(0);
                    }
                    this.cdr.detectChanges();
                }, 0);
            }
            else {
                setTimeout(() => {
                    this.runSlide();
                }, 1000);
            }
        }

	    animateRow(idx) {
	        setTimeout(() => {
		        $(".wallboardViewSlide[mid=" + this.moduleKey + "]:last").find("#row" + idx).fadeIn(1000);
	        }, 500 * idx);
	    };

	    async updateSlideData() {
            let response: any = await this.service.getCurrentAgentStatesResponsiveModuleData(this.wvcasf.Slide.WallboardID, this.moduleKey);
	        this.currentAgentStatesData = response.data;
	    }

	    getStateColor(state) {
		    if (state !== undefined) {
			    // Default Colors:
			    switch (state) {
				    case EState.Available:
					    return _stateColors.green;
				    case EState.Inbound:
					    return _stateColors.purple;
				    case EState.Outbound:
					    return _stateColors.yellow;
				    case EState.Unavailable:
				    default: // possibly: Mixed
					    return _stateColors.red;
			    }
		    }
		    return 'unset';
	    }
    }
